import { render } from "./FormTab.vue?vue&type=template&id=5653f9cb"
import script from "./FormTab.vue?vue&type=script&lang=js"
export * from "./FormTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__